export default (props, vars) => () =>
  !vars?.['defaultbox145']?.['item']?.['empty'] &&
  vars?.['defaultbox145']?.['item']?.['status'] !== 'LOCKED' &&
  vars?.['usestatestepopened']?.['setState']((s) => !s);
